module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Bold.3e2e5fdd.ttf";